/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { forwardRef } from "react";

/**
 * @deprecated Use plain HTML elements with Tailwind classes or shadcn components instead.
 * Kept only as a thin polymorphic wrapper (`Box`) for existing consumers.
 */
const Base: ComponentWithChildren = forwardRef(
  ({ as, component, sx, style, forwardRef: fRef, ...props }, ref) => {
    const Component = component || as || "div";
    const ComponentElement = Component as any;
    return (
      <ComponentElement
        ref={fRef ?? ref}
        style={sx ?? style}
        {...props}
      />
    );
  }
);

export default Base;
